import Ajax from '@utils/ajax';

export default {
  // API"S for the current user, mainly useful for the edit spotlight flow

  // to fetch status of the spotlight edit flow, helpful in continuing the edit flow where user last left
  // response = {
  //   gallery_items_added: true/false, done with the step of adding gallery_items,
  //   values_added: true/false, done with the step of adding values,
  //   interests_added: true/false, done with the step of adding interest successfully
  //   expertises_added: true/false, done with the step of adding expertise successfully
  //   enabled: true/false,
  // }
  getCurrentUserSpotlightStatus(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/status`,
      data: {},
      ...options,
    });
  },

  // enable: true/false to enable or disbale creator spotlight
  // response = same as getCurrentUserSpotlightStatus
  enableDisableSpotlight(enabled) {
    return Ajax.post({
      url: `/creator_spotlight/enable`,
      data: { enabled: enabled },
    });
  },

  // mark a section/sections as complete
  // expertises_added: true | gallery_items_added: true | interests_added: true | values_added:true
  // response = same as getCurrentUserSpotlightStatus
  markSpotlightSectionAsComplete(data) {
    return Ajax.post({
      url: `/creator_spotlight/mark_section_complete`,
      data: data,
    });
  },

  // getAll* are static data API's added to populate dropdowns/ questions selector sections etc

  // returns all the values for the populating the dropdown spotlight values
  getAllSpotlightValues(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/values`,
      data: {},
      ...options,
    });
  },

  // returns all the expertises for the populating the dropdown spotlight expertises
  getAllSpotlightExpertises(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/expertises`,
      data: {},
      ...options,
    });
  },

  // returns all the interests for the populating the dropdown spotlight interests
  getAllSpotlightInterests(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/interests`,
      data: {},
      ...options,
    });
  },

  // returns all the brands for the populating the dropdown spotlight brands
  getAllSpotlightBrands(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/brands`,
      data: {},
      ...options,
    });
  },

  // returns all the questions for the populating the dropdown spotlight questions tabs
  getAllSpotlightQuestions(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/questions`,
      data: {},
      ...options,
    });
  },

  // SpotlightValues Section
  // get current_user spotlight values
  // response: {"values":[{"id":4,"value":"Luxury"},{"id":6,"value":"Trendy"},{"id":9,"value":"Sustainable"}]}
  getSpotlightValues() {
    return Ajax.get({
      url: `/spotlight_values`,
    });
  },

  // create current_user spotlight value
  // data = {id: 8}
  createSpotlightValue(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_values`,
      data: data,
      ...options,
    });
  },

  // delete current_user spotlight value
  // response: { removed: true }
  deleteSpotlightValue(id) {
    return Ajax.post({
      url: `/spotlight_values/${id}`,
      data: {
        _method: 'DELETE',
      },
    });
  },

  // reorder current_user spotlight values
  // data = {ordered_ids: [6, 9, 2]}
  // response: { success: true }
  //           { success: false, message: failure message }
  reorderSpotlightValues(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_values/reorder`,
      data: data,
      ...options,
    });
  },

  // SpotlightBrands Section
  // get current_user spotlight brands
  // response: {"brands":[{"id":4,"value":"Trader Joe's"},{"id":6,"value":"The Ordinary"},{"id":9,"value":"Ritz-Carlton"}]}
  getSpotlightBrands() {
    return Ajax.get({
      url: `/spotlight_brands`,
    });
  },

  // create current_user spotlight brand
  // data = {id: 8}
  createSpotlightBrand(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_brands`,
      data: data,
      ...options,
    });
  },

  // delete current_user spotlight brand
  // response: { removed: true }
  deleteSpotlightBrand(id) {
    return Ajax.post({
      url: `/spotlight_brands/${id}`,
      data: {
        _method: 'DELETE',
      },
    });
  },

  // reorder current_user spotlight brands
  // data = {ordered_ids: [6, 9, 2]}
  // response: { success: true }
  //           { success: false, message: failure message }
  reorderSpotlightBrands(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_brands/reorder`,
      data: data,
      ...options,
    });
  },

  // SpotlightExpertises Section
  // get current_user spotlight expertises
  // response: {"expertises":[{"id":4,"value":"Weddings & Events"},{"id":6,"value":"Home Decor"},{"id":9,"value":"Baby & Kids"}]}
  getSpotlightExpertises() {
    return Ajax.get({
      url: `/spotlight_expertises`,
    });
  },

  // create current_user spotlight expertise
  // data = {id: 8}
  createSpotlightExpertise(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_expertises`,
      data: data,
      ...options,
    });
  },

  // delete current_user spotlight expertise
  // response: { removed: true }
  deleteSpotlightExpertise(id) {
    return Ajax.post({
      url: `/spotlight_expertises/${id}`,
      data: {
        _method: 'DELETE',
      },
    });
  },

  // reorder current_user spotlight expertises
  // data = {ordered_ids: [6, 9, 2]}
  // response: { success: true }
  //           { success: false, message: failure message }
  reorderSpotlightExpertises(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_expertises/reorder`,
      data: data,
      ...options,
    });
  },

  // SpotlightInterests Section
  // get current_user spotlight interests
  // response: {"interests":[{"id":4,"value":"Meditation"},{"id":6,"value":"Running"},{"id":9,"value":"Skincare"}]}
  getSpotlightInterests() {
    return Ajax.get({
      url: `/spotlight_interests`,
    });
  },

  // create current_user spotlight interest
  // data = {id: 8}
  createSpotlightInterest(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_interests`,
      data: data,
      ...options,
    });
  },

  // delete current_user spotlight interest
  // response: { removed: true }
  deleteSpotlightInterest(id) {
    return Ajax.post({
      url: `/spotlight_interests/${id}`,
      data: {
        _method: 'DELETE',
      },
    });
  },

  // reorder current_user spotlight interests
  // data = {ordered_ids: [6, 9, 2]}
  // response: { success: true }
  //           { success: false, message: failure message }
  reorderSpotlightInterests(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_interests/reorder`,
      data: data,
      ...options,
    });
  },

  // SpotlightQuestions Section
  // get current_user spotlight questions
  // response: {"questions":[{"id":4,"value":"A life goal of mine","answer":"A life goal of mine is to continuously learn, grow, and make a positive impact on the world"},{"id":6,"value":"The last time I cried happy tears was","answer":"answer2"},{"id":9,"value":"My greatest strength","answer":"answer3"}]}
  getSpotlightQuestions() {
    return Ajax.get({
      url: `/spotlight_questions`,
    });
  },

  // create current_user spotlight question
  // data = {id: 4, answer: 'A life goal of mine is to continuously learn, grow, and make a positive impact on the world'}
  createSpotlightQuestion(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_questions`,
      data: data,
      ...options,
    });
  },

  // delete current_user spotlight question
  // response: { removed: true }
  deleteSpotlightQuestion(id) {
    return Ajax.post({
      url: `/spotlight_questions/${id}`,
      data: {
        _method: 'DELETE',
      },
    });
  },

  // update current_user spotlight question
  // response: { }
  updateSpotlightQuestion(id, newAnswer) {
    return Ajax.post({
      url: `/spotlight_questions/${id}`,
      data: {
        answer: newAnswer,
        _method: 'PATCH',
      },
    });
  },

  // SpotlightGalleryItems Section
  // get current_user spotlight gallery_items
  // response: {"gallery_items":[{"id":89,"content_url":"url_1","content_type":null},{"id":90,"content_url":"url2","content_type":null},{"id":91,"content_url":"url3","content_type":null}]}
  getSpotlightGalleryItems() {
    return Ajax.get({
      url: `/spotlight_gallery_items`,
    });
  },

  // create current_user spotlight gallery_item
  // data = {content_url: 'content_url'}
  createSpotlightGalleryItem(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_gallery_items`,
      data: data,
      ...options,
    });
  },

  // delete current_user spotlight gallery_item
  // response: { removed: true }
  deleteSpotlightGalleryItem(id) {
    return Ajax.post({
      url: `/spotlight_gallery_items/${id}`,
      data: {
        _method: 'DELETE',
      },
    });
  },

  // reorder current_user spotlight gallery_items
  // data = {ordered_ids: [6, 9, 2]}
  // response: { success: true }
  //           { success: false, message: failure message }
  reorderSpotlightGalleryItems(data, options = {}) {
    return Ajax.post({
      url: `/spotlight_gallery_items/reorder`,
      data: data,
      ...options,
    });
  },

  // update basic information birthday, location, school and job title of the current user during the edit flow
  // data = {birthday: 'mm/dd/yyyy', location: 'California', job_title: 'Software engineer', school: 'Stanford'}
  updateBasicInformation(currentUser, data, options = {}) {
    return Ajax.post({
      url: `/users/${currentUser.id}`,
      data: { user: data, _method: 'PATCH' },
      ...options,
    });
  },

  // returns basic information for creator spotlight of the current user, to be used in the edit flow
  getBasicInformation(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/basic_information`,
      data: {},
      ...options,
    });
  },

  // returns all lists of the current user, to be used in the edit flow for populating lits dropdown to select pinned lists
  getAllLists(options = {}) {
    return Ajax.get({
      url: `/creator_spotlight/groups`,
      data: {},
      ...options,
    });
  },

  // pin or unpin a list. pinned: true/false
  updatePinnedStatusOfGroup(groupId, pinned, options = {}) {
    return Ajax.post({
      url: `/groups/${groupId}`,
      data: { only_status: true, group: { pinned_on_spotlight: pinned }, _method: 'PATCH' },
      ...options,
    });
  },

  // return the spotlight information of the passed user, to be used for displaying the spotlight of a user
  // response structure : {id:4,
  //  gallery_items:[],
  //  values:[],
  //  interests:[],
  //  expertises:[],
  //  brands:[],
  //  questions:[],
  //  invited_by_user:{:id:6645, :name:"Sahil", :avatar:"", :profile_url:""},
  //  social_profiles:[],
  //  pinned_lists:[],
  //  basic_information:{:birthday:nil, :location:nil, :job_title:nil, :school:nil},
  //  followers_information:{:followers_count:0, :top_three_followers:[]}}
  getCreatorSpotlightInformation(user, options = {}) {
    return Ajax.get({
      url: `/users/${user.id}/creator_spotlight?exclude_followers=1&exclude_lists=1`,
      data: {},
      ...options,
    });
  },

  getCreatorSpotlightFollowersInformation(user, options = {}) {
    return Ajax.get({
      url: `/users/${user.id}/spotlight_followers_info`,
      data: {},
      ...options,
    });
  },

  getCreatorSpotlightPinnedLists(user, options = {}) {
    return Ajax.get({
      url: `/users/${user.id}/spotlight_lists`,
      data: {},
      ...options,
    });
  },
};
